import * as React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styled from 'styled-components'
import Router from 'next/router'
import { useTranslation } from 'i18n'

import { AppShell } from 'components/atomic/standalone/layouts'
import { Button } from 'components/atomic/standalone/atoms/Button'
import { Info } from 'components/atomic/standalone/molecules/Info'

type Props = {
  title: string
  description: string
}
export const ErrorBase: React.FC<Props> = ({ title, description }) => {
  const s = useStyles()
  const { t } = useTranslation('standalone.error')

  return (
    <AppShell className={s.appshell}>
      <Top>
        <Info size="large" title={title} description={description} />
      </Top>

      <Bottom>
        <ButtonBlock>
          <Button
            variant="contained"
            color="primary"
            onClick={() => Router.push('/standalone/home', '/home')}
          >
            {t('backToTop')}
          </Button>
        </ButtonBlock>
        <Background />
      </Bottom>
    </AppShell>
  )
}

const Top = styled.div`
  margin-top: 35px;
  height: 175px;
  padding-left: 22px;
  padding-right: 22px;
`

const Bottom = styled.div(
  ({ theme: { assets, breakpoints: b } }) => `
  height: 400px;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 600px;
  ${b.down('sm')} {
    width: 100%;
  }
`
)

const Background = styled.div(
  ({
    theme: {
      assets,
      breakpoints: b,
      customStyle: {
        ErrorBase: { background },
      },
    },
  }) => ({
    position: 'absolute',
    bottom: 0,
    backgroundImage: assets?.error ? `url(${assets.error})` : 'none',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom',
    backgroundSize: 'contain',
    height: 400,
    width: 570,
    [b.down('sm')]: {
      width: 'calc(100% - 30px)',
    },
    ...background,
  })
)

const ButtonBlock = styled.div(
  ({ theme: { breakpoints: b } }) => `

  z-index: 10;
  position: absolute;
  bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-self: center;
  width: 550px;
  ${b.down('sm')} {
    width: calc(100% - 35px);
  }
`
)

const useStyles = makeStyles(({ palette }) => ({
  appshell: {
    backgroundColor: `${palette.background.primary} !important`,
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}))
